import { SET_USER_TRACKING_DIALOG_OPEN, SET_USER_TRACKING_STATUS } from '@/common/user-tracking/user-tracking-actions'
import { USER_TRACKING_KEY, userTrackingState } from '@/common/user-tracking/user-tracking-constants'

export const userTrackingReducer = (state = null, action = {}) => {
  // define default state if not present
  //  (can't do it in signature as property shouldOpen depends on property trackingState)
  if (state === null) {
    let trackingState
    let value = localStorage?.getItem?.(USER_TRACKING_KEY)
    try {
      trackingState = value ? JSON.parse(value) : []
    } catch (e) {
      // happens for e.g. non-parsable string from legacy settings
      value = null // so mark this as null to open the dialog
      trackingState = []
    }
    state = {
      trackingState,
      shouldOpen: value === null,
    }
  }

  switch (action.type) {
    case SET_USER_TRACKING_STATUS:
      localStorage.setItem(USER_TRACKING_KEY, JSON.stringify(action.payload.trackingState || []))
      return { ...state, trackingState: action.payload.trackingState }
    case SET_USER_TRACKING_DIALOG_OPEN:
      return { ...state, shouldOpen: action.payload.shouldOpen }
    default:
      return state
  }
}
